import { CCol, CFormGroup, CLabel, CRow } from "@coreui/react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { ErrorText } from "src/components";
import DatePicker from "src/components/DatePicker/DatePicker";

const PeriodInputs = ({ onChange, data, errors }) => {
  const { t } = useTranslation();

  const currentDate = new Date();
  const TODAY = currentDate.toISOString().split("T")[0];
  const PAST_DAY = getDayYearInThePast().toISOString().split("T")[0];

  const convertDateString = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  function getDayYearInThePast(date = new Date()) {
    const previous = new Date(date.getTime());
    previous.setDate(date.getDate() - 364);

    return previous;
  }

  const maxStartDate = Math.min(
    new Date().getTime(),
    new Date(data?.["periodTo"] || "").getTime() - 60 * 60 * 24 * 1000
  );

  return (
    <CCol>
      <CRow className="d-flex justify-content-between align-items-end">
        <CFormGroup className="pl-0 col">
          <CLabel>{t("shared.from", "From")}</CLabel>

          <DatePicker
            maxDate={new Date(maxStartDate)}
            name="periodFrom"
            onChange={(e) => {
              onChange(e);
            }}
            value={data["periodFrom"]}
            className="w-100"
            placeholderText={convertDateString(PAST_DAY)}
            isClearable
          />
          <ErrorText value={errors["periodFrom"]} />
        </CFormGroup>
        <CFormGroup className="col pr-0">
          <CLabel>{t("shared.to", "To")}</CLabel>

          <DatePicker
            minDate={new Date(data?.["periodFrom"] || "")}
            name="periodTo"
            onChange={(e) => {
              onChange(e);
            }}
            value={data["periodTo"]}
            className="w-100"
            placeholderText={convertDateString(TODAY)}
            isClearable
          />
          <ErrorText value={errors["periodTo"]} />
        </CFormGroup>
      </CRow>
    </CCol>
  );
};

export default PeriodInputs;
